var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-page"},[(_vm.link)?_c('section',[_c('LinkItem',{attrs:{"link":_vm.link}})],1):_c('section',[_c('p',[_vm._v("this link doesn't exist...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }